import { render, staticRenderFns } from "./InstallWebapp.vue?vue&type=template&id=2870da84&scoped=true"
import script from "./InstallWebapp.vue?vue&type=script&lang=js"
export * from "./InstallWebapp.vue?vue&type=script&lang=js"
import style0 from "./InstallWebapp.vue?vue&type=style&index=0&id=2870da84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2870da84",
  null
  
)

export default component.exports